// extracted by mini-css-extract-plugin
export default {"toggle":"toggle___2mhxk","open":"open___K6X5d","main":"main___2-tgS","header":"header___3vwoH","center":"center___2jpBJ","form":"form___1gbWw","noBackground":"noBackground___2qxfk"};